import React, {lazy, Suspense} from 'react';
import {Route, Routes} from 'react-router-dom';

import {PageLoading} from '@/component';
import {showAtDev} from '@/env';
import NotFoundPage from '@/page/NotFoundPage';

const MediaNewsListViewPage = lazy(() =>
    import(/* webpackChunkName: "article.mediaNewsView" */ '@/page/article/MediaNewsListViewPage')
);
const MediaNewsViewPage = lazy(() =>
    import(/* webpackChunkName: "article.mediaNewsView" */ '@/page/article/MediaNewsViewPage')
);
const MessageNewsViewPage = lazy(() =>
    import(/* webpackChunkName: "article.newsView" */ '@/page/article/MessageNewsViewPage')
);
const ArticleSearchPage = lazy(() =>
    import(/* webpackChunkName: "article.search" */ '@/page/article/articleSearch/ArticleSearchPage')
);
const DemoPage = lazy(() =>
    import(/* webpackChunkName: "app.demo" */ '@/page/DemoPage')
);

export default function AppRoutes() {
    return (
        <Suspense fallback={<PageLoading />}>
            <Routes>
                <Route
                    path="/"
                    element={React.createElement(require('@/page/HomePage').default)}
                />

                <Route
                    path="/login"
                    element={React.createElement(require('@/page/auth/LoginPage').default)}
                />
                <Route
                    path="/sso"
                    element={React.createElement(require('@/page/auth/BISsoPage').default)}
                />
                {/* <Route
                    exact
                    path="/forget"
                    component={require('@/page/auth/ForgetPassPage').default}
                />
                <Route
                    exact
                    path="/password-reset"
                    component={require('@/page/auth/PasswordResetPage').default}
                />
                <Route
                    exact
                    path="/change-passord"
                    component={require('@/page/auth/ChangePassPage').default}
                /> */}

                <Route
                    path="/profile"
                    element={React.createElement(require('@/page/ProfilePage').default)}
                />

                {showAtDev && (
                    <Route
                        path="/dev/icons"
                        element={React.createElement(require('@/page/IconsPage').default)}
                    />
                )}

                {showAtDev && (
                    <Route
                        path="/dev-login"
                        element={React.createElement(require('@/page/auth/DevLoginPage').default)}
                    />
                )}

                {/* v6 的 path 默认精确匹配（end:true），有子路由的父级必须带 /*，
                    否则 /apps/123/xxx、/admin/xxx 会落到下面的 NotFoundPage */}
                <Route
                    path="/apps/:appId/*"
                    element={React.createElement(require('@/page/app/AppPage').default)}
                />
                <Route
                    path="/admin/*"
                    element={React.createElement(require('@/page/admin/AdminPage').default)}
                />

                <Route
                    path="/conversation/external"
                    element={React.createElement(require('@/page/conversation/ExternalPage').default)}
                />
                <Route
                    path="/conversation/internal"
                    element={React.createElement(require('@/page/conversation/InternalPage').default)}
                />
                <Route
                    path="/conversation/customer"
                    element={React.createElement(require('@/page/conversation/CustomerPage').default)}
                />
                <Route
                    path="/conversation/advance"
                    element={React.createElement(require('@/page/conversation/ConPage').default)}
                />

                <Route
                    path="/customer/manage"
                    element={React.createElement(require('@/page/customer/CustomPage').default)}
                />
                <Route
                    path="/customer/tag"
                    element={React.createElement(require('@/page/customer/CustomerTagPage').default)}
                />
                <Route
                    path="/customer/room"
                    element={React.createElement(require('@/page/customer/RoomPage').default)}
                />

                <Route
                    path="/article/media/:mediaId"
                    element={<MediaNewsListViewPage />}
                />
                <Route
                    path="/article/media-news/:mediaId/:newsId"
                    element={<MediaNewsViewPage />}
                />
                <Route
                    path="/article/news/:msgId/:newsId"
                    element={<MessageNewsViewPage />}
                />

                <Route
                    path="/article/search"
                    element={<ArticleSearchPage />}
                />
                <Route
                    path="/demo"
                    element={<DemoPage />}
                />

                <Route path="*" element={<NotFoundPage showButton />} />
            </Routes>
        </Suspense>
    );
}
